async function checkPending() {
    return this.api({
        url: `/tasks/`,
        method: 'GET'
    })
}

export default {
    pluginName: 'tasks',
    methods: {
        checkPending
    }
}